import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useApi from "../../hooks/useApi";

import RenderActivities from "../../Components/RenderActivities";
import StarRating from "../../Components/StarRating";

import Input from "../../Components/Input";
import CustomButton from "../../Components/CustomButton";
import CustomSelect from "../../Components/Select";
import RequestWizard from "../../Components/RequestWizard";
import Loader from "../../Components/Loader";
import CustomModal from "../../Components/CustomModal/CustomModal";

import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

import { ReactComponent as Share } from "../../static/images/share.svg";
import { ReactComponent as Filter } from "../../static/images/filter_icon.svg";
import { ReactComponent as UserIcon } from "../../static/images/user_profile.svg";
import { ReactComponent as FullStar } from "../../static/images/full_star.svg";

import { useToast } from "../../store/ToastProvider/ToastProvider";

import "./style.scss";

const FindProviderReasult = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { get, loading } = useApi();
  const { showToast } = useToast();
  const coachesRef = useRef([]);

  const [searchParams] = useSearchParams();

  const [filteredCoaches, setFilteredCoaches] = useState();
  const [selectedCoach, setSelectedCoach] = useState();
  const [categoryActivities, setCategoryActivities] = useState();
  const [subActivities, setSubActivities] = useState();

  const [isWizardOpen, setIsWizardOpen] = useState(false);

  const [nameFilter, setNameFilter] = useState("");
  // const [locationFilter, setLocationFilter] = useState("");

  const [filterOpen, setFilterOpen] = useState(false);

  const getAllQueries = (tag) => {
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    // Check if the value is "all"
    if (params[tag] === "all") {
      return "";
    }

    return params[tag] || "";
  };

  const fetchReview = async () => {
    try {
      const response = await get(
        `/Providers?ActivityName=${getAllQueries(
          "activity",
        )}&ActivityCategory=${getAllQueries(
          "category",
        )}&Availability=${getAllQueries("availability")}`,
      );

      coachesRef.current = response;
      setFilteredCoaches(response);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  const fetchCategoryActivities = async (category) => {
    try {
      const response = await get(`/Providers/Services`);

      let allCategory = response.activites.flatMap((item) => item.category);

      if (category && category !== "all") {
        const categoryItem = response.activites.find(
          (item) => item.category.toLowerCase() === category.toLowerCase(),
        );

        setSubActivities(categoryItem.subCategories);
      } else {
        let allActivities = response.activites.flatMap(
          (item) => item.subCategories,
        );

        setSubActivities(allActivities);
      }

      setCategoryActivities(allCategory);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchReview();
  }, [searchParams]);

  useEffect(() => {
    fetchCategoryActivities();
  }, []);

  const handleBookingRequest = (event, coach) => {
    event.stopPropagation();
    setSelectedCoach(coach);
    setIsWizardOpen(true);
  };

  const handleWizardClose = () => {
    setIsWizardOpen(false);
    setSelectedCoach(null);
  };

  const updateQuery = (newQueries) => {
    const params = new URLSearchParams(searchParams.toString());

    Object.keys(newQueries).forEach((key) => {
      const value = newQueries[key];

      if (value !== undefined && value !== null && value !== "") {
        params.set(key, value); // Update or add the query
      } else {
        params.delete(key); // Remove the query if value is empty
      }
    });

    // Update the URL without full page reload
    navigate(`?${params.toString()}`, { scroll: false });
  };

  const disabledClearButton = () => {
    if (
      // locationFilter.length ||
      nameFilter.length ||
      getAllQueries("category") !== "" ||
      getAllQueries("availability") !== "" ||
      getAllQueries("activity") !== ""
    ) {
      return false;
    }
    return true;
  };

  const clearFilters = () => {
    // filterByLocation("");
    filterByName("");
    updateQuery({
      category: "all",
      availability: "all",
      activity: "all",
    });
  };

  const handleCopyLink = (coach, event) => {
    event.preventDefault();
    event.stopPropagation();
    const coachUrl = `${window.location.origin}/provider-details/${coach.providerId}`;
    navigator.clipboard.writeText(coachUrl).then(() => {
      showToast({
        title: t("link_copied"),
        description: t("coach_profile_copied", { name: coach.name }),
      });
    });
  };

  const filterByName = (value) => {
    setNameFilter(value);
    setFilteredCoaches(
      coachesRef.current.filter((userName) =>
        userName.name.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  };
  // const filterByLocation = (value) => {
  //   setLocationFilter(value);
  //   setFilteredCoaches(
  //     coachesRef.current.filter(
  //       (coachAddress) =>
  //         coachAddress.address.address
  //           .toLowerCase()
  //           .includes(value.toLowerCase()) ||
  //         coachAddress.address.city.toLowerCase().includes(value.toLowerCase()),
  //     ),
  //   );
  // };

  return (
    <div className="search-result-container">
      {/* Hero Section with Background Pattern */}
      <div className="search-results-hero">
        {/* <div className="overlay"></div> */}
        <div
          className="background-pattern"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        ></div>
        <div className="content-wrapper">
          <div className="content-container">
            <div className="content-flex">
              <div className="text-section">
                {getAllQueries("activity") === "" ? null : (
                  <h1>
                    {t("search_results_for")} "{t(getAllQueries("activity"))}"
                  </h1>
                )}

                <p>
                  {t("found")} {filteredCoaches && filteredCoaches.length}{" "}
                  {t("coach")}
                  {filteredCoaches &&
                  i18n.language === "en" &&
                  filteredCoaches.length !== 1
                    ? "es" + " " + t("matching_your_search")
                    : ""}
                </p>
              </div>
              {getAllQueries("activity") && (
                <div className="image-section">
                  <div className="image-wrapper">
                    <div className="result-image">
                      <RenderActivities
                        activities={getAllQueries("activity")}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="filter-container">
        <div
          className="filter-container-haeeder"
          onClick={() => {
            setFilterOpen((preVal) => !preVal);
          }}
        >
          <div className="filter-icon">
            <Filter />
            <h5>{t("filter_coaches")}</h5>
          </div>
          <KeyboardDoubleArrowDownIcon />
        </div>

        {filterOpen === true && (
          <>
            <div className="filter-sections">
              <div className="filter-card">
                <div className="filter-input input">
                  <Input
                    placeholder={t("search_placeholder")}
                    value={nameFilter}
                    onChange={(e) => filterByName(e.target.value)}
                    label={t("coach_name")}
                  />
                </div>
              </div>
              <div className="filter-card">
                <div className="filter-input">
                  {categoryActivities && (
                    <CustomSelect
                      options={[
                        {
                          label:
                            getAllQueries("category") === "all" ||
                            getAllQueries("category") === ""
                              ? t("all_categories")
                              : t("all_categories"),
                          value: "all",
                        },
                        ...categoryActivities.map((item) => ({
                          label: t(item.toLowerCase()),
                          value: item.toLowerCase(),
                        })),
                      ]}
                      label={t("categories")}
                      value={
                        getAllQueries("category") === ""
                          ? "all"
                          : getAllQueries("category")
                      }
                      onChange={(e) => {
                        updateQuery({
                          category: e.target.value,
                          activity: "all",
                        });
                        fetchCategoryActivities(e.target.value);
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="filter-card">
                <div className="filter-input">
                  {subActivities && (
                    <CustomSelect
                      options={[
                        {
                          label:
                            getAllQueries("activity") === ""
                              ? t("all_activities")
                              : t("all_activities"),
                          value: "all",
                        },
                        ...subActivities.map((item) => ({
                          label: t(item.toLowerCase()),
                          value: item.toLowerCase(),
                        })),
                      ]}
                      label={t("activity_type")}
                      value={
                        getAllQueries("activity") === ""
                          ? "all"
                          : getAllQueries("activity")
                      }
                      onChange={(e) => {
                        updateQuery({
                          activity: e.target.value,
                        });
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="filter-card">
                <div className="filter-input select">
                  <CustomSelect
                    options={[
                      {
                        label: t("available_only"),
                        value: "true",
                      },
                      {
                        label: t("busy_only"),
                        value: "false",
                      },
                      {
                        label: t("all_coaches"),
                        value: "all",
                      },
                    ]}
                    value={
                      getAllQueries("availability") === ""
                        ? "all"
                        : getAllQueries("availability")
                    }
                    label={t("availability")}
                    onChange={(e) => {
                      updateQuery({ availability: e.target.value });
                    }}
                  />
                </div>
              </div>
              {/* <div className="filter-card">
                <div className="filter-input input">
                  <Input
                    placeholder={t("search_location")}
                    value={locationFilter}
                    onChange={(e) => filterByLocation(e.target.value)}
                    label={t("location")}
                  />
                </div>
              </div> */}
            </div>

            <div className="clear-filter">
              <CustomButton
                onClick={clearFilters}
                disabled={disabledClearButton()}
              >
                {t("clear_filters")}
              </CustomButton>
            </div>
          </>
        )}
      </div>

      {/* Cards Grid */}
      <div className="provider-card-container">
        <ul>
          {filteredCoaches &&
            filteredCoaches.map((coach) => {
              return (
                <li
                  key={coach.providerId}
                  onClick={() => {
                    navigate(`${coach.providerId}`);
                  }}
                >
                  <div className="card-info">
                    <div className="card-image">
                      <div>
                        {coach.profileUrl ? (
                          <img src={coach.profileUrl} alt={""} />
                        ) : (
                          <UserIcon />
                        )}
                      </div>
                    </div>
                    <div className="card-name">
                      <div>
                        <h4>{coach.name}</h4>
                      </div>
                      <div className="card-name-activity">
                        <span>{t(coach.activity)}</span>
                      </div>
                      {coach.avarageRating === null ? (
                        <div className="card-rating">
                          <FullStar />
                          <span>{t("new_on_skedy")}</span>{" "}
                        </div>
                      ) : (
                        <div>
                          <StarRating rating={coach.avarageRating} />
                        </div>
                      )}
                    </div>

                    <div
                      className="card-share"
                      onClick={(e) => {
                        handleCopyLink(coach, e);
                      }}
                    >
                      <Share />
                    </div>
                  </div>

                  {coach.about && (
                    <div className="card-about">
                      <span className="text-sm text-gray-600">
                        {i18n.language === "ka" && coach.aboutGeorgian
                          ? coach.aboutGeorgian
                          : coach.about}
                      </span>
                    </div>
                  )}

                  <div className="card-avaliability">
                    {coach.available ? (
                      <span className="available">{t("available")}</span>
                    ) : (
                      <span className="busy">{t("busy")}</span>
                    )}
                  </div>
                  <div className="card-location">
                    <span>{coach?.address?.city},</span>
                    <span>{coach?.address?.district}</span>
                  </div>

                  <div className="card-book-btn">
                    <CustomButton
                      onClick={(event) => handleBookingRequest(event, coach)}
                      disabled={!coach.available}
                    >
                      {t("request_booking")}
                    </CustomButton>
                  </div>
                </li>
              );
            })}
        </ul>
      </div>
      {filteredCoaches && filteredCoaches.length === 0 && (
        <div className="no-coaches-container">
          <div className="no-coaches-content">
            <h3 className="no-coaches-title">{t("no_coaches_found")}</h3>
            <p className="no-coaches-description">{t("adjusting_search")}</p>
            <CustomButton onClick={clearFilters} variant="outline">
              {t("clear_all_filters")}
            </CustomButton>
          </div>
        </div>
      )}

      <CustomModal open={isWizardOpen} onClose={() => setIsWizardOpen(false)}>
        <RequestWizard
          isOpen={true}
          onClose={handleWizardClose}
          coach={selectedCoach}
        />
      </CustomModal>

      {loading && <Loader />}
    </div>
  );
};

export default FindProviderReasult;
